import React from 'react';
import { connect } from 'react-redux';
import fields, { globalFieldLengths } from '@/constants/fields';
import DictionaryInput from '../../dictionaries/components/DictionaryInput';
import LookupValue from './LookupValue';
import LookupValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/LookupValueContainer';

const LookupDescription = ({
  description,
  lookupItemUUID,
  isEditing,
  exists,
  canRead,
  updateProperties,
  saveErrors,
}) => {
  const updateLookupDescription = (value) => (
    updateProperties(lookupItemUUID, { description: value, isDirty: true })
  );

  if (!isEditing) {
    return (<LookupValue value={description} className="td-editable-name" />);
  }

  const error = saveErrors.find((e) => (
    e.context.lookupItemUUID === lookupItemUUID && e.fields.includes(fields.DESCRIPTION)));

  return (
    <LookupValueContainer exists={exists} canRead={canRead}>
      <DictionaryInput
        error={error}
        fluid
        type="lookup.item.description"
        text={description}
        onChange={updateLookupDescription}
        maxLength={globalFieldLengths.description}
      />
    </LookupValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupDescription);
